module.exports = __webpack_public_path__ + "img/category_32.948ea2cb.png";